// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"0c7c90c5","453":"9d2e5b0c","732":"703c68d5","977":"0bc7bacc"}[chunkId] + ".chunk.js";
};